import React from "react";
import "../Styles/Footer.css"; // for styles

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        <span className="label">Support :</span>{" "}
        <a href="tel:+971 50 5483488" className="link">+971 50 5483488 |</a> 
        <a href="mailto:motiwala.tourism@gmail.com " className="link">motiwala.tourism@gmail.com </a>
      </p>
    </footer>
  );
}
